import { render, staticRenderFns } from "./CircleArrow.vue?vue&type=template&id=4b0f2e14&"
import script from "./CircleArrow.vue?vue&type=script&lang=ts&"
export * from "./CircleArrow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports